import { useEffect, useCallback, useContext } from "react";
import { AuthContext } from "../providers/AuthProvider";
import { signOut } from "../services/firebase";
import { useRegionSettings } from "../providers/RegionSettingsProvider";

const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 10 minutes

const ACTIVITY_EVENTS = [
  "mousedown",
  "mousemove",
  "keypress",
  "scroll",
  "touchstart",
  "click",
] as const;

export function useInactivityLogout() {
  const { user } = useContext(AuthContext);
  const { isFeatureEnabled } = useRegionSettings();
  const autoLogoutEnabled = isFeatureEnabled("autoLogoutEnabled");

  const handleLogout = useCallback(() => {
    signOut();
  }, []);

  useEffect(() => {
    if (!user || !autoLogoutEnabled) return;

    let timeoutId: ReturnType<typeof setTimeout>;

    const resetTimer = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(handleLogout, INACTIVITY_TIMEOUT);
    };

    ACTIVITY_EVENTS.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [user, autoLogoutEnabled, handleLogout]);
}
